export default __webpack_public_path__ + "static/media/atritec-map-image.09367d16.PNG";